import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HttpService } from './http.service';
import { APIS } from '../../common/constants';
import { CreateUser } from '../../models/user';
import { ControlPoint } from '../../models/meta.model';

@Injectable({ providedIn: 'root' })
export class UserService {
  valueChange = new Subject<any>();
  componentUpdate = new Subject<any>();
  recordsUpdate = new Subject<any>();

  constructor(
    private httpService: HttpService
  ) {
  }

  getUsers(query: Record<string, any>): Observable<any> {
    return this.httpService.getData(APIS.USERS.BASE, query);
  }

  getManagedInspectors(query: Record<string, any>): Observable<any> {
    return this.httpService.getData(APIS.INSPECTOR_MANAGEMENT.INSPECTORS, query);
  }

  createUser(data: CreateUser): Observable<any> {
    return this.httpService.postData(APIS.USERS.BASE, data);
  }

  updateUser(userId: string, data: Record<string, any>): Observable<any> {
    return this.httpService.putData(`${APIS.USERS.BASE}/${userId}`, data);
  }

  deleteUser(userId: string): Observable<any> {
    return this.httpService.deleteData(`${APIS.USERS.BASE}/${userId}`);
  }

  getProductCategoryUsers(userId: string): Observable<any> {
    return this.httpService.getData(`${APIS.USERS.BASE}/${userId}/product-category-users`);
  }

  getMyLocations(): Observable<any> {
    return this.httpService.getDataWithCache(APIS.USERS.MY_LOCATIONS);
  }

  getMyControlPoints(): Observable<ControlPoint[]> {
    return this.httpService.getData(APIS.USERS.MY_CONTROL_POINTS);
  }
}
